module.exports = __webpack_public_path__ + "img/CR_oceanShippingbotton.bd511546.png";